<div class="modal-title-div d-flex justify-content-between align-items-center py-2 px-4">
  <h4 class="modal-title card-title" id="exampleModalLabel">
    @if (!showReportGeneration) {
      {{'Export File' | translate}}
    }
    @if (showReportGeneration) {
      {{'Generate Report' | translate}}
    }
  </h4>
  <button type="button" class="close" (click)="cancel()"><span aria-hidden="true">×</span></button>
</div>

@if (!showReportGeneration) {
  <mat-dialog-content class="custom-scrollbar">
    <div class="row">
      <div class="col-12 col-md-7 risk-checkbox-left-col">
        <div class="lists-container row mb-3">
          <div class="col-12 col-lg-4">
            <div class="list custom-scrollbar">
              <h3 class="bold">
                <mat-checkbox [(ngModel)]="segAllSelected"
                (change)="selectionChange(segsList, $event.checked, true)">{{'Segs' | translate}}</mat-checkbox>
              </h3>
              @for (seg of segsList; track trackByIndex($index)) {
                <div class="list-item">
                  <mat-checkbox (change)="selectionChange(segsList, $event.checked, false, 'segAllSelected')"
                    [(ngModel)]="seg.selected">
                    {{ seg.segName }}
                  </mat-checkbox>
                </div>
              }
            </div>
          </div>
          <div class="col-12 col-lg-4">
            <div class="list custom-scrollbar">
              <h3 class="bold">
                <mat-checkbox [(ngModel)]="agentAllSelected"
                (change)="selectionChange(agentsList, $event.checked, true)">{{'Agents' | translate}}</mat-checkbox>
              </h3>
              @for (agent of agentsList; track trackByIndex($index)) {
                <div class="list-item">
                  <mat-checkbox
                    (change)="selectionChange(agentsList, $event.checked, false, 'agentAllSelected')"
                    [(ngModel)]="agent.selected">
                    {{ agent.agentName }}
                  </mat-checkbox>
                </div>
              }
            </div>
          </div>
          <div class="col-12 col-lg-4">
            <div class="list custom-scrollbar">
              <h3 class="bold">
                <mat-checkbox (change)="selectionChange(statisticList, $event.checked, true, '', false)"
                [(ngModel)]="statisticAllSelected">{{'Statistics' | translate}}</mat-checkbox>
              </h3>
              @for (statistic of statisticList; track trackByIndex($index)) {
                <div class="list-item">
                  <mat-checkbox (change)="selectionChange(statisticList, $event.checked, false, 'statisticAllSelected', false)"
                    [(ngModel)]="statistic.selected">
                    {{ statistic.value }}
                  </mat-checkbox>
                </div>
              }
            </div>
          </div>
        </div>
        <div class="rating-section">
          <ng-container *ngTemplateOutlet="riskRatings"></ng-container>
        </div>
        <div class="text-content mt-3 mb-4">
          <p>{{'Report generated using SEGs, Agents, and Statistics' | translate}}</p>
          <p>{{'*Seg may have different date range' | translate}}</p>
        </div>
        <div class="btn-div">
          <a class="btn modal-footer-btn save-modal-btn w-100" (click)="generateReport()">{{'Generate Report' | translate}}</a>
        </div>
        <div class="mt-2">
          <a class="btn modal-footer-btn save-modal-btn w-100" (click)="exportToExcel()">{{'Export Risk Summary Report as xlsx' | translate}}</a>
        </div>
      </div>
      <div class="col-12 col-md-5 risk-assesment-right-col">
        <div class="preview-report" id="risk-register-report">
          <div class="logo-date-head mt-2 mb-4 d-flex justify-content-between">
            <div class="company-logo">
              @if (logoUrl) {
                <img [src]="logoUrl" alt="Company Logo" class="tenant-logo">
              }
            </div>
            <span>{{'Report Date:' | translate}} {{currentDate | dateFormat}}</span>
          </div>
          <div class="card-details text-center">
            <h4 class="card-title">{{riskAssessment.name}}</h4>
            <span>{{riskAssessment.periodStart | dateFormat}} -
            {{riskAssessment.periodEnd | dateFormat}}</span>
          </div>
          <div class="table-section">
            @if (!isTableLoading) {
              <div class="table-responsive custom-theme-table custom-scrollbar">
                @if (dataSource.length) {
                  <table mat-table class="table outer-bordered-table" [dataSource]="dataSource"
                    >
                    <ng-container matColumnDef="segCode">
                      <th mat-header-cell *matHeaderCellDef>{{'SEG Code' | translate}}</th>
                      <td mat-cell class="bordered-cell" *matCellDef="let element">
                        {{ element?.segCode ?? '-' }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="segName">
                      <th mat-header-cell *matHeaderCellDef>{{'SEG Name' | translate}}</th>
                      <td mat-cell class="bordered-cell" *matCellDef="let element; let i = index"
                        [attr.rowspan]="element.rowSpan" [ngClass]="element.displayClass">
                        {{element.segName}}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="numberOfWorkers">
                      <th mat-header-cell *matHeaderCellDef>{{'No of Employees' | translate}} </th>
                      <td mat-cell *matCellDef="let element" class="bordered-cell">
                        {{ element?.numberOfWorkers ?? '-' }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="numberOfContractors">
                      <th mat-header-cell *matHeaderCellDef>{{'No of Contractors' | translate}} </th>
                      <td mat-cell *matCellDef="let element" class="bordered-cell">
                        {{ element?.numberOfContractors ?? '-' }}
                      </td>
                    </ng-container>
                    @for (value of extraColumns; track trackByIndex(index); let index = $index) {
                      <ng-container [matColumnDef]="value.agentName">
                        <th mat-header-cell *matHeaderCellDef>
                          <div>{{value.agentName}} </div>
                          <div>{{'Consequence Rating' | translate}}: {{value.consequenceRating}}</div>
                        </th>
                        <td class="bordered-cell" *matCellDef="let element">
                          @for (register of element.registers; track trackByIndex($index)) {
                            @if (register.agentId === value.agentId) {
                              <div class="analyte-cell" [ngStyle]="{'background-color': register.color}">
                                @for (statistic of statisticList; track trackByIndex($index)) {
                                  @if (statistic.selected) {
                                    <span class="d-block">
                                      {{ statistic.tableKey + ' = ' + (register.statisticValues?.[statistic.key] || '-') }}
                                    </span>
                                  }
                                }
                              </div>
                            }
                          }
                        </td>
                      </ng-container>
                    }
                    <ng-container matColumnDef="groupHeader">
                      <td mat-cell class="bordered-cell group-header-cell" *matCellDef="let element"
                        [attr.colspan]="displayedColumns.length">{{ element.label }}</td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: groupHeaderColumns; when: isGroupHeaderRow"></tr>
                    <tr mat-row *matRowDef="let row; let even = even; columns: displayedColumns;"
                    class="even-row"></tr>
                  </table>
                } @else {
                  <div [innerHTML]="noDataError"></div>
                }
              </div>
            }
            @if (isPreviewCapped) {
              <p class="mt-2 mb-0">{{ 'Preview shows the first {{count}} SEGs. The export includes every selected SEG.' | translate: { count: previewSegCount } }}</p>
            }
            @if (isTableLoading) {
              <app-widget-loader
              class="vertically-center-div w-100 justify-content-center"></app-widget-loader>
            }
          </div>
          <div class="d-flex mt-2">
            <ng-container *ngTemplateOutlet="riskRatings"></ng-container>
          </div>
          <div class="text-content mt-2">
            <p>{{'Report generated using SEGs, Agents, and Statistics' | translate}}</p>
          </div>
        </div>
      </div>
    </div>
  </mat-dialog-content>
}

@if (showReportGeneration && reportEntity) {
  <app-report-generation-popup
    [entity]="reportEntity"
    [entityType]="entityType"
    [entityId]="riskAssessment.id"
    [isVisible]="true"
    (close)="cancel()"
    (pdfGenerated)="onPdfGenerated($event)">
  </app-report-generation-popup>
}

<ng-template #riskRatings>
  @for (level of riskLevels; track trackByIndex(i); let i = $index) {
    <div class="rating-item">
      <span class="rating-square" [ngStyle]="{'background-color':level.Color}"></span> {{ riskLevelLabels[i] }}
    </div>
  }
</ng-template>
